import { useLayoutEffect } from 'react';
import { useLocation, useNavigationType } from 'react-router-dom';

/** Place beside a lazy page inside its Suspense boundary, so the reset waits for page content. */
export const PageNavigationScrollReset = (): null => {
  const { hash } = useLocation();
  const navigationType = useNavigationType();

  useLayoutEffect(() => {
    // A new page starts at its heading. History visits and explicit anchors keep their position.
    if (navigationType !== 'POP' && !hash) window.scrollTo({ left: 0, top: 0, behavior: 'auto' });
  }, [hash, navigationType]);

  return null;
};
